import {useState} from 'react';

import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';

import CustomTextField from '../common/CustomTextField';

import { useGetLocationsQuery } from '../../redux/services/locationApi';

const SearchLocationForm = ({ searchLocation }) => {
  const [coordinates, setCoordinates] = useState({ lat: 42.478394, lon: -83.146, radius: 30 });
  const locationQuery = useGetLocationsQuery(
    {...coordinates}, 
    { skip: coordinates.lat === null || coordinates.lon === null }
  );
  const locations = locationQuery?.data?.data || [];
  return (
    <Grid container spacing={1}>
      <Grid item xs={12}>
        <Typography variant='h2'>Search Location</Typography>
      </Grid>
      <Grid item xs={12}>
        <CustomTextField
          name="lat"
          label="Latitude"
          variant='outlined'
          placeholder="Latitude"
          type="number"
          value={coordinates.lat}
          onChange={e => setCoordinates({...coordinates, lat: e.target.value})}
        />
      </Grid>
      <Grid item xs={12}>
        <CustomTextField
          name="lon"
          label="Longitude"
          variant='outlined'
          placeholder="Longitude"
          type="number"
          value={coordinates.lon}
          onChange={e => setCoordinates({...coordinates, lon: e.target.value})}
        />
      </Grid>
      <Grid item xs={12}>
        <CustomTextField
          name="lon"
          label="Radius"
          variant='outlined'
          placeholder="Radius"
          type="number"
          value={coordinates.radius}
          onChange={e => setCoordinates({...coordinates, radius: e.target.value})}
        />
      </Grid>
      <Grid item xs={12}>
        {locations?.length
          ? locations.map(l => (
            <div>
              <Typography variant='h3'>{l.name}</Typography>
              <Typography variant='body1'>{l.address_line_1}</Typography>
              <Typography variant='body1'>{l.address_line_2}</Typography>
              <Typography variant='body1'>{l.address_city}, {l.address_state} {l.address_zip}</Typography>
              <Typography variant='body1'>({l.lat}, {l.lon})</Typography>
            </div>
          ))
          : <div>No Locations</div>
        }
      </Grid>
    </Grid>
  );
};

export default SearchLocationForm;